import { createActions, createReducer } from "reduxsauce";
export default function* config() {}
/*-----------Action types & creators-------------*/
export const { Types, Creators } = createActions({
  message: ["message"],
  clearMessage: null,
});

/*------------Reducers-----------*/
const INITIAL_STATE = {
  message: null,
};

const message = (state = INITIAL_STATE, { message }) => ({
  ...state,
  message: message,
});

const clearMessage = (state = INITIAL_STATE) => ({
  ...state,
  message: null,
});

const HANDLERS = {
  [Types.MESSAGE]: message,
  [Types.CLEAR_MESSAGE]: clearMessage,
};
export const reducersConfig = createReducer(INITIAL_STATE, HANDLERS);
